(function () {
  function initMobileMenuLabel() {
    document.querySelectorAll('.cv-mobile-nav').forEach(function (nav) {
      var summary = nav.querySelector('summary');
      if (!summary) return;
      var label = summary.querySelector('[data-cv-mobile-label]');

      function syncLabel() {
        if (label) {
          label.textContent = nav.open ? 'Fermer' : 'Menu';
        }
      }

      nav.addEventListener('toggle', syncLabel);
      syncLabel();
    });
  }

  function initStickyProductOffset() {
    var stickyBuy = document.querySelector('.cv-product-sticky-buy');
    if (!stickyBuy) return;

    var lastHeight = -1;
    function syncStickyProductOffset(entries) {
      var entry = entries && entries[0];
      var borderBox = entry && entry.borderBoxSize;
      var box = borderBox && (borderBox[0] || borderBox);
      var height = box && box.blockSize
        ? Math.round(box.blockSize)
        : Math.round(stickyBuy.offsetHeight);
      if (height === lastHeight) return;
      lastHeight = height;
      document.documentElement.style.setProperty('--cv-mobile-buy-height', height + 'px');
    }

    window.requestAnimationFrame(syncStickyProductOffset);
    if ('ResizeObserver' in window) {
      var stickyObserver = new ResizeObserver(syncStickyProductOffset);
      stickyObserver.observe(stickyBuy);
    } else {
      window.addEventListener('resize', syncStickyProductOffset, { passive: true });
    }
  }

  function init() {
    initMobileMenuLabel();
    initStickyProductOffset();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
